import React from 'react';
import Button from 'react-bootstrap/Button';
import { AjaxLeadFormModel } from '../../models/globals';
import { CtpLeadModal } from './CtpLeadModal';

interface CtpContactUsButtonProps {
    className?: string;
    leadFormModel: AjaxLeadFormModel;
}

const CtpContactUsButton: React.FC<CtpContactUsButtonProps> = ({ className = '', leadFormModel }) => {
    const contactUsBtnTextLower = 'contact us';
    const [showContactUsForm, setShowContactUsForm] = React.useState(false);

    return (
        <>
            <Button
                aria-label={contactUsBtnTextLower} // otherwise screenreaders might read uppercase US as U.S.
                className={`${className} font-weight-bold px-5 text-uppercase`.trim()}
                onClick={() => setShowContactUsForm(true)}
                variant="primary"
            >
                {contactUsBtnTextLower}
            </Button>

            <CtpLeadModal
                onHide={() => setShowContactUsForm(false)}
                leadFormModel={leadFormModel}
                show={showContactUsForm}
            />
        </>
    );
};

export { CtpContactUsButton };
